import EventEmitter from 'events';


class ZoneSelectorControlBase extends EventEmitter {
  // Subclasses must implement:
  // selectZone(zoneId) { }
  // selectZoneGroup(zoneGroupId) { }
  // destroy() { }

  notifyZoneChange(zoneId) {
    this.emit('change', zoneId);
  }

  getZoneGroupItems(zoneGroupId) {
    return this.items.filter(item => item.zoneGroupId === zoneGroupId);
  }

  getItem = zoneId => this.items.find(item => item.zoneId === zoneId);

  getZoneGroupIdForZone = (zoneId) => {
    const item = this.getItem(zoneId);

    if (item) {
      return item.zoneGroupId;
    }

    return '';
  }

  getZoneIds() {
    return this.items
      .map(item => item.zoneId);
  }

  deselectZoneGroupItems(zoneGroupId) {
    this.getZoneGroupItems(zoneGroupId)
      .forEach((item) => {
        item.isSelected = false;
      });
  }

  getIsZoneGroupAvailable(zoneGroupId) {
    return this.items
      .some(item => item.zoneGroupId === zoneGroupId);
  }

  getIsZoneAvailable(zoneId) {
    const item = this.getItem(zoneId);

    if (item) {
      return item.isAvailable;
    }

    return false;
  }

  getSelectedZoneIdForZoneGroup(zoneGroupId) {
    const zoneGroupItems = this.getZoneGroupItems(zoneGroupId);
    const availableZoneGroupItems = zoneGroupItems
      .filter(item => item.isAvailable);

    let zoneId = '';

    if (availableZoneGroupItems.length === 1) {
      zoneId = availableZoneGroupItems[0].zoneId;
    } else {
      const selectedItem = zoneGroupItems.find(item => item.isSelected);

      if (selectedItem) {
        zoneId = selectedItem.zoneId;
      }
    }

    return zoneId;
  }
}


export default ZoneSelectorControlBase;
